import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import type { AxiosResponse } from "axios";
import type {
  ContactConflictPreview,
  ContactConflictSummary,
  ResolveContactConflictRequest,
  ResolveContactConflictResponse,
} from "../dtos/contact-conflicts";
import { isContactConflictUid } from "../utils/contact-conflicts";

const baseUrl = `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/contact-conflicts`;

function requireUid(uid: string) {
  if (!isContactConflictUid(uid))
    throw new Error("Invalid contact conflict identifier");
  return uid;
}

export async function getPendingContactConflicts(journeyUId: string) {
  requireUid(journeyUId);
  const response = await fetchFromBrandedUrl<
    AxiosResponse<{ items: ContactConflictSummary[] }>
  >({
    options: {
      brandedUrl: brandUrl(baseUrl),
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: { journeyUId },
    },
  });
  return response.data.items;
}

export async function getContactConflict(uid: string) {
  const response = await fetchFromBrandedUrl<
    AxiosResponse<ContactConflictPreview>
  >({
    options: {
      brandedUrl: brandUrl(`${baseUrl}/${requireUid(uid)}`),
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  });
  return response.data;
}

export async function resolveContactConflict(
  uid: string,
  data: ResolveContactConflictRequest,
) {
  const response = await fetchFromBrandedUrl<
    AxiosResponse<ResolveContactConflictResponse>
  >({
    options: {
      brandedUrl: brandUrl(`${baseUrl}/${requireUid(uid)}/resolve`),
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      data,
    },
  });
  return response.data;
}
